@if (file || isHeader) {
  <div (click)="onActivate($event)"
[ngClass]="{
  'rowHeader' : isHeader,
  'itemHeader': isHeader,
  'row' : !isHeader,
  'itemActive': (file == selectedFile || file?.isChecked) && !isHeader,
  'itemNew': file?.isNew
}"
    >
    @if (isMultiselect && !isHeader) {
      <div class="checkboxCol bringToFront">
        <button mat-icon-button title="{{ file?.isChecked ? 'auswählen' : 'abwählen' }}">
          <i class="material-icons">{{ file?.isChecked ? 'check_box' : 'check_box_outline_blank' }}</i>
        </button>
      </div>
    }
    @if (isMultiselect && isHeader) {
      <div class="checkboxCol bringToFront">
        <button mat-icon-button (click)="toggleAllSelect()" title="{{ allSelected ? 'Alle auswählen' : 'Alle abwählen' }}" [disabled]="filesLength < 1">
          <i class="material-icons invert-icon">{{ allSelected ? 'check_box' : 'check_box_outline_blank' }}</i>
        </button>
      </div>
    }
    <div class="titleCol bringToFront">
      {{file?.fileName}}
    </div>
    <div class="dateCol bringToFront" >
      {{file?.fileDate | date}}
    </div>
    <div class="sizeCol bringToFront" >
      @if (!isHeader) {
        {{file?.fileBytes | fileSize}}
      }
    </div>
    <div class="statusCol bringToFront" >
      @if (file?.isNew) {
        <i class="material-icons iconActive" title="Neue Datei (noch nicht werwendet / heruntergeladen)">star</i>
      }
    </div>
    <div class="buttonCol bringToFront" >
      @if (!isHeader) {
        <button mat-menu-item (click)="deleteItem($event)" title="Diese Datei  löschen">
          <i class="material-icons">delete</i>
        </button>
      }
      @if (isHeader) {
        <button mat-menu-item (click)="deleteAllItems()" title="Alle Dateien löschen" [disabled]="filesLength < 1">
          <i class="material-icons invert-icon">delete</i>
        </button>
      }
    </div>
    <div class="buttonCol bringToFront" >
      @if (!isHeader) {
        <button mat-menu-item (click)="download($event)" title="Datei herunterladen" >
          <i class="material-icons">get_app</i>
        </button>
      }
      @if (isHeader) {
        <button mat-menu-item (click)="downloadAllItems()" title="Alle herunterladen" [disabled]="true || filesLength < 1"> <!--Wenn funktionstüchtig implementiert "True" entfernen-->
          <i class="material-icons invert-icon">get_app</i>
        </button>
      }
      <!--     <button  [matMenuTriggerFor]="menu"  (click)="$event.stopPropagation()">
      <i class="material-icons md-12">more_vert</i>
    </button>
  -->  </div>
</div>
}
<!--
<mat-menu #menu="matMenu">
  <p class="menuTitle">{{item.name}}</p>
  <button mat-menu-item  (click)="onActivate(true, null)" title="Koordinations-Ansicht bearbeiten" >
    <i class="material-icons md-16">adjust</i>
    <span>aktivieren</span>
  </button>
  <button mat-menu-item  (click)="onActivate(false, null)" title="Teilmodell-Versionen laden (keine sperrende Aktivierung)" >
    <i class="material-icons md-16">panorama_fish_eye</i>
    <span>laden</span>
  </button>
  <button mat-menu-item  (click)="updateItem()" title="Koordinations-Ansicht bearbeiten" >
    <i class="material-icons md-16">edit</i>
    <span>bearbeiten</span>
  </button>
  <button mat-menu-item  (click)="deleteItem()" title="Koordinations-Ansicht löschen" >
    <i class="material-icons md-16">delete</i>
    <span>löschen</span>
  </button>
</mat-menu>

-->
